import {createContext} from 'react'
import {IModuleState} from '@/types/state';



export interface IModuleContextState<T extends IModuleState> {
    state: T
    defaultState: T
    setState: <k extends keyof T = keyof T>( key: k, value: T[k]) => void
    cleanState: () => void
}

export const INITIAL_STATE = {
    state: {module: 'home'}
} as IModuleContextState<IModuleState>


export const buildInitialState = <T extends IModuleState>(defaultValue?: T): IModuleContextState<T> => {
    return {
        state: defaultValue ? defaultValue : {module: 'unknown'}
    } as IModuleContextState<T>
}

export const ModuleContext = createContext<IModuleContextState<IModuleState>>(INITIAL_STATE)


